import React from "react";
import FollowButton from "./FollowButton";
import useDevice from "../hooks/useDevice";

const ArtistTile = ({ data = {} }) => {
  const { isDesktop, isTablet } = useDevice();

  let desktopProfileImg =
    data.profileImg || "/site/images/artist/no-profile-img.png";

  return (
    <div
      style={{
        display: "flex",
        padding: 16,
        background: "#FFFFFF",
        borderRadius: 8,
        boxShadow: "-4px 4px 4px 0px rgba(0, 0, 0, 0.08)",
        gap: 16,
        width: isDesktop
          ? "calc((100% - 2*16px) / 3)"
          : isTablet
          ? "calc((100% - 16px) / 2)"
          : "100%",
      }}
    >
      <a style={{ height: 80 }} href={data.documentUrl}>
        <img
          src={desktopProfileImg}
          style={{
            height: 80,
            width: 80,
            objectFit: "cover",
            borderRadius: 200,
            boxShadow: "0 4px 4px 0 rgba(0, 0, 0, 0.08)",
          }}
        ></img>
      </a>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <a
          title={`Συναυλίες & Events ${data.title}`}
          style={{
            color: "#0D0C1C",
            fontSize: 16,
            fontFamily: "pf_highway_sans_pro_mediumRg",
            display: "-webkit-box",
            overflow: "hidden",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            textDecoration: "none",
          }}
          href={data.documentUrl}
        >
          {data.title}
        </a>
        <FollowButton artistNodeId={data.nodeId} />
      </div>
    </div>
  );
};

export default ArtistTile;
